// extracted by mini-css-extract-plugin
module.exports = {"IAndCSecurityMonitor":"IAndCSecurityMonitor_IAndCSecurityMonitor__2-Sya"};